import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_PETITION_ACTIVITY = createFcmDetails(
	'starter_experience_petition_activity',
	{
		owner: 'Starter Experience (Axolotl) Team',
		context: 'corgi_frontend',
		description: 'Enables the visibility of links to the Petition Activity page in Starter Dashboard V2',
		import: false,
	},
);
